import styled from 'styled-components';

import {
  Dropdown,
  DropdownOptionLabel,
} from '@sorare/core/src/atoms/dropdowns/Dropdown';
import { SBHorizontal } from '@sorare/core/src/atoms/layout/flex';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

export const StyledDropdown = styled(Dropdown)`
  width: 50%;
  flex-grow: 1;
  @media ${tabletAndAbove} {
    width: auto;
    flex-grow: auto;
  }
`;

export const StyledDropdownOptionLabel = styled(DropdownOptionLabel)`
  background-color: var(--c-nd-50);
  white-space: nowrap;
`;

export const ButtonLabel = styled(SBHorizontal)`
  width: 100%;
`;
